import clsx from "clsx";

interface HeaderProps {
	title: string;
	description?: string;
	id: string;
}

const Header = ({ title, description, id }: HeaderProps) => {
	return (
		<div className={clsx("flex flex-col gap-6 text-center md:mx-auto")}>
			<h2 className="font-bold text-3xl tracking-tight sm:text-4xl" id={id}>
				{title}
			</h2>
			{description && <p className="text-lg tracking-tight">{description}</p>}
		</div>
	);
};

export default Header;
